import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
The main entry point for Exercise Dress Hero Page.

Referenced by page.exercise-dress.liquid templates.
* */
import React from 'react';
import ReactDOM from 'react-dom';
import ProductStory from './components/ProductStory';
import props from './components/ProductStory/exercise-dress-props';
import './scss/templates/page-exercise-dress.scss';
/* eslint-disable max-len */

import { jsx as _jsx } from "react/jsx-runtime";

var init = function init() {
  ReactDOM.render( /*#__PURE__*/_jsx(ProductStory, _objectSpread({}, props)), document.getElementById('page-exercise-dress'));
};

init();